import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { defaultDomains } from "../../constants";

function Copyright(props) {
	const domain = window.location.hostname;

	if (!defaultDomains.includes(domain)) return null;

	return (
		<Typography
			variant="body2"
			color={props?.sx?.color ? props?.sx?.color : "#fff"}
			align="center"
			{...props}
		>
			{"Copyright © "}
			<Link
				color={props?.sx?.color ? props?.sx?.color : "#fff"}
				href="https://cargoseller.pl/"
			>
				www.cargoseller.pl
			</Link>{" "}
			{new Date().getFullYear()}
			{"."}
		</Typography>
	);
}

export default Copyright;
